"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 29. 10. 2020
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converter for {@link ProductCategoryChangeProcess category tree changes processing}.
 *
 * @author Radek Beran
 */


var ProductCategoryChangeProcessConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ProductCategoryChangeProcessConverter, _DataObjectConverter_);

  function ProductCategoryChangeProcessConverter() {
    _classCallCheck(this, ProductCategoryChangeProcessConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductCategoryChangeProcessConverter).apply(this, arguments));
  }

  return ProductCategoryChangeProcessConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ProductCategoryChangeProcessConverter = ProductCategoryChangeProcessConverter;